import React, { useState, useEffect } from 'react';
import { Cookies } from '../../../index.js';
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { alert_error, alert_success } from '../../../AppContext';
const App = () => {
  const { slug_1, slug_2 } = useParams();
  const ok2 = Cookies.get('apikey');
  const [listcauhinh, setListcauhinh] = useState(null);
  const [nickdangdung, setNickdangdung] = useState(null);
  const [chedokiemxu, setChedokiemxu] = useState(2);
  const [tenfb, setTenfb] = useState('');
  const [nutxuly, setNutxuly] = useState(null);
  const [idfacebook, setIdfacebook] = useState(null);
  const [randomNumber] = useState(Math.floor(Math.random() * 100) + 1);

  useEffect(() => {
    if (!ok2) {
      alert('Vui lòng đăng nhập');
    } else {
      checktk();
    }
  }, [ok2]);

  const checktk = () => {
    axios
      .post('https://hust.media/insta/profile.php', {
        key: ok2,
        chedo: 'listcauhinh',
        social: slug_1,
      })
      .then((response) => {
        const info = response.data;
        console.log(info);
        asdasdkas(info);
        setTimeout(() => {
          const script = document.createElement('script');
          script.src = 'https://www.vipads.live/vn/c-726-25.js';
          document.getElementById('themquangcao').appendChild(script);
        }, 200);
      })
      .catch((error) => console.log(error));
  };

  const asdasdkas = (info) => {
    if (info.status == 3) {
      alert_success('Vui lòng thêm tài khoản chéo Facebook');
      switch_router('/reactapp/insta/themcauhinh');
    } else if (info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 1) {
      alert_success(info.message);
      setListcauhinh(info.listcauhinh);
      setNickdangdung(info.nickdangdung);
      if (info.chedokiemxu) {
        setChedokiemxu(info.chedokiemxu);
      }
    }
  };

  const handleChange = (value) => {
    setTenfb(value.tenfb);
    setIdfacebook(value.idfacebook);
  };

  const xacnhan = () => {
    setNutxuly(1);
    axios
      .post('https://hust.media/insta/profile.php', {
        key: ok2,
        idfacebook: idfacebook,
        chedo: 'choncauhinh',
        chedokiemxu: chedokiemxu,
        social: slug_1,
        tenfb: tenfb,
      })
      .then((response) => {
        const info = response.data;
        console.log(info);
        dssdsdvsdvsdv(info);
      })
      .catch((error) => console.log(error));
  };

  const dssdsdvsdvsdv = (info) => {
    if (info.status == 0) {
      alert_error(info.message);
    } else if (info.status == 3) {
      alert_success(info.message);
      switch_router('/reactapp/insta/themcauhinh');
    } else if (info.status == 1) {
      alert_success(info.message);
      switch_router('/reactapp/sunflower/' + slug_1 + '/home');
    } else if (info.status == 4) {
      alert_error(info.message);
    }
    setNutxuly(0);
  };

  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  return (
    <div className="row fixrow">
      <div className="max-h-16">
        <div className="cards">
          <ins
            className="adsbygoogle"
            style={{ display: 'block' }}
            data-ad-client="ca-pub-4574266110812955"
            data-ad-slot="1627514116"
            data-full-width-responsive="no"
            data-ad-format="horizontal"
          ></ins>
        </div>
      </div>
      <div className="text-center">
        <Link to="/reactapp/insta/themcauhinh">
          <button type="button" className="mx-2 btn-sm btn-primary">
            THÊM NICK {slug_1} ĐỂ CHẠY
          </button>
        </Link>
        <Link to={"/reactapp/sunflower/" + slug_1 + "/home"}>
          <button type="button" className="mx-2 btn-sm btn-primary">
            Chéo {slug_1}
          </button>
        </Link>
      </div>
      <div className="max-w-2xl py-4 mx-auto rounded-lg shadow-xl">
        <div className="panel px-10 panel-primary">
          <div className="panel-heading">
            <h4 className="text-white">DANH SÁCH NICK {slug_1}</h4>
          </div>
          <div className="panel-body">
            {listcauhinh == null ? (
              <div className="container-fluid">
                <div className="row" style={{ backgroundColor: '#FFB6C1' }}>
                  <p className="text-center" style={{ color: '#fff' }}>
                    <div className="text-center spinner-border" role="status"></div>
                    <br />
                    Đang tải danh sách
                  </p>
                </div>
              </div>
            ) : (
              <div className="container-fluid">
                {nickdangdung == null ? (
                  <div className="container-fluid">
                    <p className="text-center" style={{ color: '#fff' }}>
                      <br />
                      <p className="text-sm"> Chọn một tài khoản {slug_1} bên dưới để làm Jop</p>
                    </p>
                  </div>
                ) : (
                  <div id="nickdangdung">
                    <label className="block font-bold">Nick đang dùng:</label>
                    <a href={nickdangdung.lienketfb} target="_blank" className="flex items-center">
                      <span>{nickdangdung.tenfb}</span>
                    </a>
                    {
                      slug_1 == 'facebook' &&
                      (<>
                        <div className="form-inline mt-2">
                          <label className="block font-bold mr-2">Chế độ kiếm Coins:</label>
                          <select
                            className="form-select"
                            value={chedokiemxu}
                            onChange={(e) => setChedokiemxu(e.target.value)}
                          >
                            <option value="1">Trình duyệt máy tính</option>
                            <option value="2">Ứng dụng Facebook</option>
                            <option value="3">Trình duyệt điện thoại</option>
                          </select>
                        </div>
                      </>)
                    }

                  </div>
                )}

                <ul id="dsnick" className="list-group mt-3 max-h-80 overflow-y-scroll">
                  {listcauhinh.map((user) => (
                    <li key={user.id} className="list-group-item">
                      <label className="radio-inline flex items-center">
                        <input
                          type="radio"
                          name="chk"
                          value={user.idfacebook}
                          onChange={() => handleChange(user)}
                          className="form-radio form-radio-lg h-6 w-6 text-pink-500"
                        />
                        <a href={user.lienketfb} target="_blank" className="flex items-center">
                          &emsp; <span>{user.tenfb}</span>
                        </a>
                      </label>
                    </li>
                  ))}
                </ul>
                <br />
                <div className="col" onClick={xacnhan}>
                  <div className="fixrow row text-center">
                    <div className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-1 w-auto dark:bg-slate-800 dark:text-white">
                      <div className="m-auto p-2">
                        <button className="flex items-center justify-start flex-1 space-x-4">
                          {nutxuly == '1' ? (
                            <div className="spinner-border" role="status"></div>
                          ) : (
                            <div>
                              <span className="font-medium px-2 text-sm">Đặt làm nick chạy </span>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="themquangcao"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
